<template>
  <div class="aboutwe_w site_min_w bc_fff ">
    <div class="d_flex site_content site_min_h">
      <div class="side_menu_w bc_fff">
        <div v-if="cmsNode">

          <div class="directory_i">
            <img :src="cmsNode.icon" alt="">
            <span class="span_1 fz16 c_fff">{{ cmsNode.name }}  </span>
          </div>

          <router-link
            v-for="(item,index) in cmsNode.children"
            :key="item.id"
            :to="`${item.nodeModel.route}/${item.id}`"
            custom
          >
            <div
              class="menu_i c333 fz16"
              :class="Number(cmsNodeChild.id) === item.id ? 'c_0983CC' : ''"
              @click="findLabel(index)"
            >
              <span>></span>
              <span class="span_2">{{ item.name }}</span>
            </div>
          </router-link>
        </div>
      </div>

      <div
        ref="mainRef"
        class="files_c_w d_flex flex_direction_col"
      >

        <div
          v-if="cmsNode"
          class="head fz12 c_1A1A1A d_flex justify_content_sb"
        >
          <el-breadcrumb v-if="cmsNodeChild" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>{{ cmsNode.name }}<span style="margin: 0 3px;color: #C0C4CC;">></span>{{ cmsNodeChild.name }}</el-breadcrumb-item>
          </el-breadcrumb>
          <el-breadcrumb v-else separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>全部结果</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <el-table
          v-if="listData && listData.list"
          :data="listData.list"
          style="width: 100%"
          highlight-current-row
        >
          <el-table-column
            prop="title"
            label="文件名"
            show-overflow-tooltip
          />

          <!-- <el-table-column
            prop="suffix"
            label="后缀"
            width="180"
          /> -->

          <el-table-column
            prop="createdAt"
            label="日期"
            show-overflow-tooltip
          />
          <el-table-column
            label="操作"
            width="145"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="
                downLocalFile(scope.row)
                "
              >下载
              </el-button>
              <el-progress v-if="scope.row.downing" :percentage="scope.row.percentage" style="white-space: nowrap;"></el-progress>
            </template>
          </el-table-column>
        </el-table>

        <div v-else class="div_4 x_y_center">
          <img src="@/assets/images/empty_icon.png" alt="">
          <span class="span_1">暂无数据</span>
        </div>

        <div class="d_flex align_item_c justify_content_c">
          <!--分页-->
          <MyPagination
            v-if="listData"
            :current-page="listData.pageNum"
            :total="listData.total"
            style="margin-top: 8px"
            change-method-name="getNodeData"
            :that="this"
            layout="total, prev, pager, next,  jumper"
          />
        </div>

      </div>
    </div>

    <ImportJs :src="static_resource + '/js/oss.js'" script-key="oss" @loadComplete="ossCompleteFn" />

  </div>
</template>

<script>
import MyPagination from '@/components/base/MyPagination.vue'
import ImportJs from '@/components/base/ImportJs.vue'
import {
  cms_files,
} from '@/api/portal'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Cookies from 'js-cookie'
import bus from '@/utils/bus'

export default {
  components: {
    MyPagination,
    ImportJs
  },
  metaInfo() {
    return {
      title: `${this.cmsNode?.name ? this.cmsNode.name+' - ' :''}${this.siteInfo?.name}`
    }
  },
  data() {
    return {
      listData: null,
      pageInfo: {
        page: 1,
        rows: 10
      },
      cmsNode: null, // 栏目node
      cmsNodeChild: null,
      index: 0
    }
  },
  computed: {
    ...mapGetters(['siteInfo', 'Bucket_pub','static_resource'])
  },
  watch: {
    $route: {
      handler(val) {
        if(Object.keys(this.siteInfo).length){
          this.findPid(this.siteInfo.nodes)
          this.getData()
        }
      },
      immediate: true
    },
    siteInfo:{
      handler(n){
        if(Object.keys(n).length){
          this.findPid(n.nodes)
        }
      },
      immediate:true,
      deep:true
    }
  },
  created() {

  },
  mounted() {},
  methods: {
    ...mapMutations({
      ossCompleteFn: 'app/ossCompleteFn'
    }),
    ...mapActions({
      'openPreviewFile': 'upload/openPreviewFile',
      downLocalFile: "upload/downLocalFile",
    }),
    findLabel(index) {
      this.index = index
    },
    // 获取数据 api
    async getData(params) {
      const { data } = await cms_files(
        Object.assign({ kind: this.cmsNodeChild?.code || '' }, params || this.pageInfo)
      )
      this.listData = data
      if(this.listData?.list?.length){
        for(let v of this.listData.list){
          this.$set(v,'downing',false)
          this.$set(v,'percentage',0)
        }
      }
      console.log(this.listData.list)
    },
    // 查询父菜单id
    findPid(nodes, parent) {
      if (nodes && nodes.length) {
        for (const i in nodes) {
          if (nodes[i].id === this.$route.params.id - 0 || nodes[i].code === 'files') {
            this.cmsNode = parent || nodes[i]
            this.cmsNodeChild = nodes[i].children[this.index]
            console.log('this.cmsNodeChild',this.cmsNodeChild)
            return
          }
          if (nodes[i].children && nodes[i].children.length) {
            this.findPid(nodes[i].children, nodes[i])
          }
        }
      }
    },



  }
}
</script>

<style lang='scss' scoped>
.aboutwe_w {
  padding: 35px 0;
  .side_menu_w {
    width: 216px;
    height: 100%;
    border: 1px solid #dbdbdb;
    margin: 0 10px 0 0;
    .directory_i {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 20px;
      background-color: #0983cc;
    }
    .menu_i {
      display: flex;
      align-items: flex-start;
      padding: 17px 20px;
      cursor: pointer;
      border-bottom: 1px solid #e6e6e6;
    }
    a{
      &:last-child{
        .menu_i{
        border: 0;

        }
      }
    }
  }
  .files_c_w {
    position: relative;
    flex: 1;
    border: 1px solid #e6e6e6;
    overflow: auto;
    min-height: 480px;
    &::-webkit-scrollbar {
      display: none;
    }
    & {
    scrollbar-width: none; //火狐
  }
  }
  .head {
    width: 100%;
    padding: 19px 20px;
    background: #e6e6e6;
  }
  .div_1 {
    height: 100%;
    padding: 0 0 30px 0;
  }
  .div_2 {
    display: inline-block;
    padding: 20px 0 14px 0;
    margin: 0 20px;
    border-bottom: 4px solid #0983cc;
  }
  .div_3 {
    padding: 15px 22px;
    border-top: 1px solid #e6e6e6;

    ::v-deep   img{
      cursor: initial ;
  }
  }
  .div_4 {
    height: 100%;
  }
  .span_1 {
    margin: 0 0 0 10px;
  }
  .span_2 {
    margin: 0 0 0 20px;
  }

}

</style>
